const canManageTags = () => true;

export default canManageTags;
